export enum NeighborsSource {
    Seatmap = 'seatmap',
    File    = 'file'
}
